import React, { useContext } from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import { TextAlignment } from 'pdf-lib';



export default function FileCard({ 
    onRemoveItem,
    children,
    imageSrc,
    openCard
}) {

    
    const handleRemoveBtn = (file) => {
        onRemoveItem(file);
    }
    
    const handleClickCard = () => {
        if(openCard){
            openCard();
        }
    }

    return (
        <Grid>
            <Card
                variant="outlined"
                onClick={handleClickCard}
                sx={{
                    p: 2,
                    width: 310,
                    // display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    backgroundColor: '#fbfafa',
                    position: 'relative',
                    boxShadow: '3',
                    '&:hover': { boxShadow: '18' , borderColor: '#c5bcbc'},
                    // maxHeight: 500,
                    // height: 450,
                    mr: 1
                }}

            >
                {onRemoveItem &&
                    <IconButton
                        size="small"
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            color: 'text.secondary'
                        }}
                        onClick={handleRemoveBtn}
                    >

                        <CloseIcon />
                    </IconButton>
                }

                <Stack direction="column" alignItems="center" spacing={1} useFlexGap>
                    <CardMedia
                        component="img"
                        // width="100"
                        height="100"
                        // src={process.env.PUBLIC_URL + '/assets/image/pdf_ico2.png'}
                        src={imageSrc}
                        sx={{
                            width: { xs: '60%', sm: 100 },
                            mb:2
                        }}
                    />

                    <div >
                        {children}
                    </div>
                </Stack>
            </Card>
        </Grid>
    );
}